function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { SWStoreImpl } from "@supersig/store";
import { createSWSchema } from "./createSWSchema";
/**
 * A helper for creating a SWStore. Custom shapes cannot override default shapes.
 *
 * @param opts - Options for creating the store.
 *
 * @public */ export function createSWStoreWithShapeNodeMap(_param) {
    var { initialData, defaultName = "" } = _param, rest = _object_without_properties(_param, [
        "initialData",
        "defaultName"
    ]);
    const schema = "schema" in rest && rest.schema ? rest.schema : createSWSchema({
        nodes: "nodeTypeMap" in rest && rest.nodeTypeMap ? rest.nodeTypeMap : {},
        loadables: "loadableTypeMap" in rest && rest.loadableTypeMap ? rest.loadableTypeMap : {}
    });
    return new SWStoreImpl({
        schema,
        initialData,
        props: {
            defaultName
        }
    });
}
